import { api } from "../config";
import { getAuthHeaders } from "../helpers/api_helper";

// The administrator settlement queue.
//
// Deliberately a raw fetch rather than APIClient: the shared axios interceptor
// rewrites every 500 to "Internal Server Error", which would swallow the one
// message an administrator most needs here — that the settlement tables have
// not been migrated yet. The server's own explanation is kept instead.
const BASE = `${api.API_URL}/api/admin/settlement`;

async function request(path = "", body) {
  const response = await fetch(`${BASE}${path}`, {
    method: body ? "POST" : "GET",
    headers: { "Content-Type": "application/json", ...getAuthHeaders() },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.error || `Request failed (${response.status})`);
  return data;
}

// The queue itself. Filters: { symbol, mode, status, priceStatus, from, to, page }.
// Resolves to { rows, total, page, busy }.
export const listSettlementPrices = (filters = {}) => {
  const query = new URLSearchParams(
    Object.entries(filters).filter(([, value]) => value !== "" && value != null)
  );
  return request(`?${query}`);
};

// Re-read every mode's forecasts into the queue. Resolves to { errors }.
export const refreshSettlementQueue = () => request("/refresh", {});

// Fetch prices for the selected windows from the market data provider.
export const fetchSettlementPrices = (ids) => request("/fetch", { ids });

// Settle every expired forecast whose window now has prices.
export const settleForecasts = (ids) => request("/settle", { ids });

// An administrator's verdict on one price window before its batches settle.
// action: confirm | adjust (with start_price / end_price) | exclude | clear; note says why.
export const reviewSettlementPrice = (id, review) => request("/review", { id, ...review });

// Correct a batch that has already settled: { mode, group_id, symbol,
// action: exclude | include | adjust, start_close, end_close, reason }.
// The mode re-scores the batch and a published article is updated.
export const correctSettlement = (correction) => request("/correct", correction);
